import { Layout, ListTitle, MTools, Tabs } from '@/components';
import { getDict, getMedia } from '@/services/api';
import React, { Component } from 'react';
import styles from './index.less';
import BetterScroll from '@better-scroll/core'
import PullUp from '@better-scroll/pull-up'
import { IMedia } from '@/models/types/media';
import loadingIcon from '@/assets/image/loading.gif';
import { createRef } from 'react';
import { IDict } from '@/models/types/dict';

interface ILocalActivityProps {

}
interface ILocalActivityState {
  current: number;
  list: IMedia[];
  size: number;
  total: number;
  loading: boolean;
  hasMore: boolean;
  themeDay: IDict[];
  dictValue: string;
}
BetterScroll.use(PullUp)

class ThemeDayActivity extends Component<ILocalActivityProps, ILocalActivityState> {
  indexRef: any
  bs: any
  constructor(props: ILocalActivityProps) {
    super(props)
    this.state = {
      current: 1,
      list: [],
      size: 10,
      total: 0,
      loading: false,
      hasMore: true,
      themeDay: [],
      dictValue: ''
    }
    this.indexRef = createRef()
  }


  componentDidMount() {
    this.getData()
    this.init()
    this.getThemeDay()
  }

  getThemeDay = async () => {
    const result = await getDict('themeDay')
    if (result.success) {
      this.setState({
        themeDay: result.data
      })
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  init = () => {
    this.bs = new BetterScroll(this.indexRef.current, {
      pullUpLoad: true,
      click: true,
      bounce: false
    })
    this.bs.on('pullingUp', () => {
      this.getData()
      this.bs.finishPullUp()
    })
  }

  getData = async () => {
    if (!this.state.hasMore) return
    this.setState({
      loading: true
    })
    const { current, size, list, dictValue } = this.state;
    const result = await getMedia({
      current,
      size,
      columnType: 'theme',
      dictValue: dictValue || undefined
    });
    if (result.success) {
      const { records, total } = result.data

      let hasMore = true
      if (+total <= (current - 1) * size + records.length) {
        hasMore = false
      }

      this.setState({
        list: [...list, ...records],
        total: total,
        current: current + 1,
        hasMore
      }, () => {
        this.bs.refresh()
      })
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }

    this.setState({
      loading: false
    })
  }
  onDictChange = (key: string) => {
    this.setState({
      current: 1,
      hasMore: true,
      dictValue: key,
      list: []
    }, this.getData)
  }
  render() {
    const { list, hasMore, current, themeDay } = this.state;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout
          breadcrumb={[{
            title: '主题日活动'
          }]}
        >
          <ListTitle title='主题日活动' />
          <div className={styles.tab}>
            <Tabs data={themeDay} onDictChange={this.onDictChange}></Tabs>
          </div>
          <div className={styles.list}>
            {list.map(item => {
              return (
                <div
                  className={styles.item}
                  key={item.id}
                  onClick={
                    () => {
                      window.open(item.url)
                    }
                  }
                >
                  <div className={styles.top}>
                    <div className={styles.title} >
                      {item.title}
                    </div>
                    <div className={styles.tag}>
                      {themeDay.find(i => i.value === item.dictValue)?.name}
                    </div>
                  </div>
                  <div className={styles.time}>
                    {item.activityTime}
                  </div>
                </div>
              )
            })}
          </div>
          <div className={styles.bottom}>
            {hasMore && current !== 1 && <div className={styles.loadMore}>
              <img src={loadingIcon} alt="" />
              加载更多
            </div>}
          </div>

        </Layout>
      </div>
    );
  }
}

export default ThemeDayActivity;

